module.exports = __webpack_public_path__ + "static/fonts/lato-bold.cccb897.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/lato-font/fonts/lato-bold/lato-bold.woff2
// module id = /1VA
// module chunks = 13